<template>
  <div class="company">
    <Headers></Headers>
    <div class="center">
      <img class="center-img" :src="bgUrl" />
      <div class="center-synopsis">
        <h3>公司简介</h3>
        <div class="synopsis-show"></div>
        <div class="synopsis-text">
          音乐窝MusicWOW立足于音乐玩创的初心，自2017年成立以来，专注于现代流行音乐教育，以“享受音乐、学习音乐、创作音乐”为核心教学理念，独创“玩、学、创”三维合一特色教学方式，为3-18岁青少儿为主的音乐爱好者提供轻松、快乐音乐体验，让他们感受音乐力量，以音乐创造快乐。
          <p>
          音乐窝致力于做真正的音乐玩创品牌，将门店升级打造为“音乐玩创中心”：致力于为学员们提供沉浸式、全方位的音乐玩、创空间与平台。依托音乐窝MusicWOW在行业的影响力，自成立以来一直保持迅猛上升发展趋势，截止2022年底，音乐窝音乐玩创中心已覆盖广州、佛山、汕头、中山、珠海、潮州、茂名、揭阳、河南周口、上海、安徽合肥、湖南郴州、海南海口等多个城市。
          </p>
        </div>
      </div>
      <div class="center-progress">
        <h3>发展历程</h3>
        <div class="synopsis-show"></div>
        <div class="progress-text">
          <ul>
            <li v-for="(item, index) in navData" :key="index">
              <div class="text-time">{{ item.date }}</div>
              <div v-if="index == 0" class="text-showFrist">
                <div class="text-circle">
                  <div class="text-show"></div>
                </div>
              </div>

              <div
                v-else-if="index == navData.length - 1"
                class="text-showLast"
              >
                <div class="text-circle">
                  <div class="text-show"></div>
                </div>
              </div>
              <div v-else class="text-showHide">
                <div class="text-circle">
                  <div class="text-show"></div>
                </div>
              </div>
              <div class="text-details">{{ item.title }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "commpany",
  data() {
    return {
      type: "",
      navData: [],
      bgUrl: "",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    handReservationBut() {
      this.$router.push({ name: "Reservation" });
    },
    async getDevelopData() {
      const developData = await this.$API.getDevelopData({});
      // console.log(developData)
      this.navData = developData.data;
    },
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "mobile_company":
            this.bgUrl = item.image;
            break;
        }
      });
    },
  },
  mounted() {},
  created() {
    this.onBulist();
    this.getDevelopData();
  },
};
</script>
<style lang="sass" scoped>
h3
  font-size: 24px
.synopsis-show
  width: 44px
  height: 5px
  background: #07D1AA
  margin: 20px auto
.company
  .center
    padding-top: 60px
    .center-img
      width: 100%
    .center-synopsis
      padding: 20px 0
      margin: 20px
      .synopsis-text
        text-align: left
        color: rgba(0,0,0,0.5)
        font-size: 14px
        line-height: 30px
        p
          margin-top: 20px
    .center-progress
      padding: 20px 0
      margin: 20px
      .progress-text

        ul
          line-height: 20px
          li
            display: flex
            font-size: 14px
            color: rgba(0,0,0,0.5)
            .text-time
              position: relative
              padding: 10px 0
            .text-time:before
              content: ''
              position: absolute
              left: 80px
              top: 0
              z-index: 0
              width: 1px
              height: 100%
              background-color: #9E9E9E
            .text-circle
              width: 12px
              height: 12px
              border: 1px solid #07D1AA
              border-radius: 50%
              position: absolute
              left: -4px
              top: 14px
            .text-details
              width: 221px
              text-align: left
              margin-left: auto
              padding: 10px 0
            .text-showFrist
              width: 8px
              height: 20px
              position: absolute
              left: 98px
              background: #fff
            .text-showHide
              height: 10px
              position: absolute
              left: 98px
            .text-showLast
              height: 80px
              position: absolute
              left: 98px
              margin-top: 15px
              background: #fff
              width: 10px
              .text-circle
                top: 0
            .text-show
              width: 5px
              height: 5px
              background: #07D1AA
              border-radius: 50%
              margin: auto
              margin-top: 4px
              z-index: 33
</style>

